// components/media/MediaPickerModal.jsx
import { useEffect, useState } from "react";
import { Modal, Upload, Button, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import api from "../../api";
import { useToast } from "../toast";

export default function MediaPickerModal({ open, onClose, onSelect }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (!open) return;
    (async () => {
      setLoading(true);
      const res = await api.media_list();
      if (res?.status === 200) setImages(res.data || []);
      else toast("Медиа авахад алдаа гарлаа", "error");
      setLoading(false);
    })();
  }, [open]);

  const upload = async ({ file }) => {
    const formData = new FormData();
    formData.append("image", file);
    const res = await api.upload_image(formData);
    if (res?.status === 201) {
      setImages((prev) => [res.data, ...prev]);
      onSelect(res.data.url);
      toast("Зураг амжилттай байршлаа", "success");
    } else {
      toast("Зураг байршуулахад алдаа гарлаа", "error");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
      centered
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingRight: 32,
          }}
        >
          <span>Зургийн сан</span>
          <Upload
            showUploadList={false}
            accept="image/jpeg,image/png,image/webp,image/svg+xml"
            customRequest={upload}
          >
            <Button icon={<UploadOutlined />} size="small">
              Компьютерээс
            </Button>
          </Upload>
        </div>
      }
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 48 }}>
          <Spin />
        </div>
      ) : (
        <div className="nd-media-grid">
          {images.length === 0 ? (
            <div className="nd-media-empty">Зураг байхгүй байна</div>
          ) : (
            images.map((img) => (
              <div
                key={img.uid || img.id}
                className="nd-media-item"
                onClick={() => onSelect(img.url)}
              >
                <img src={img.url} alt={img.name || ""} />
              </div>
            ))
          )}
        </div>
      )}
    </Modal>
  );
}
